import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DynamicFieldComponent } from '../../models/dynamic-field-component';
import { DynamicFormEntry } from '../../models/dynamic-form-entry';


@Component({
  selector: 'bom-header-label',
  templateUrl: './header-label.component.html',
  styleUrls: ['./header-label.component.scss'],
})

export class HeaderLabelComponent implements DynamicFieldComponent  {
  config: DynamicFormEntry;
  group: FormGroup;
  ShowingToggelContent = true;

  HeaderToggel(config: DynamicFormEntry ) {
    const domRepresentation = document.getElementsByClassName(config.toggleClassName);

    for (let i = 0; i < domRepresentation.length; i++) {
      if ($(domRepresentation[i + 1]).css('display') === 'block') {
        $(domRepresentation[i + 1]).css('display', 'none');
      } else {
        $(domRepresentation[i + 1]).css('display', 'block');
      }
    }


    if ($(domRepresentation[0]).css('display') === 'block') {
      $(domRepresentation[0]).css('display', 'none');
    } else {
      $(domRepresentation[0]).css('display', 'block');
    }


    this.ShowingToggelContent = !this.ShowingToggelContent;
  }

  ShowingToggelContentArrow(config: DynamicFormEntry): boolean {
    const domRepresentation = document.getElementsByClassName(config.toggleClassName);
    return $(domRepresentation[0]).css('display') === 'block';
  }

}

